export enum UserRoleEnum {
    USER = "U",
    ADMIN = "A",
    OWNER = "O",
    NONE = ''
}